var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickarrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 238436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1448 20.1366L3.3067 13.2219C2.54474 12.4514 1.33343 12.4514 0.571468 13.2219C-0.190489 13.9924 -0.190489 15.2173 0.571468 15.9878L8.75762 24.2657C9.51958 25.0362 10.7504 25.0362 11.5124 24.2657L32.222 3.34375C32.984 2.57326 32.984 1.34837 32.222 0.577872C31.46 -0.192624 30.2487 -0.192624 29.4868 0.577872L10.1448 20.1366Z",
    fill: "#0DBF8D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickarrow);
export default __webpack_public_path__ + "static/media/tickarrow.91eaa40c9831dc5913113c1e32df00ac.svg";
export { ForwardRef as ReactComponent };